import { calculateVerticalRhythm, setChildMap } from './utils';
// Text spacing refers to the space on the top and bottom of a Text Set
// Text can be in "compact" or "comfortable" mode
// When it's compact, spacing is the same across all breakpoints
// When it's comfy, spacing is determined by the breakpoint
var SectionTextPadding = new Map();
SectionTextPadding.set('COMPACT', setChildMap('TOP', calculateVerticalRhythm(4)).set('BOTTOM', calculateVerticalRhythm(5)));
SectionTextPadding.set('COMFORTABLE', setChildMap('LARGE', setChildMap('TOP', calculateVerticalRhythm(8)).set('BOTTOM', calculateVerticalRhythm(9)))
    .set('MEDIUM', setChildMap('TOP', calculateVerticalRhythm(7)).set('BOTTOM', calculateVerticalRhythm(8)))
    .set('SMALL', setChildMap('TOP', calculateVerticalRhythm(6)).set('BOTTOM', calculateVerticalRhythm(7))));
// Getter for text spacing
export var getTextSectionPadding = function (_a) {
    var spacingMode = _a.spacingMode, verticalSpacingFor = _a.verticalSpacingFor, screenSize = _a.screenSize;
    var mode = SectionTextPadding.get(spacingMode);
    if (spacingMode === 'COMPACT') {
        return mode === null || mode === void 0 ? void 0 : mode.get(verticalSpacingFor);
    }
    if (spacingMode === 'COMFORTABLE') {
        if (screenSize) {
            var bp = mode === null || mode === void 0 ? void 0 : mode.get(screenSize);
            if (typeof bp === 'object') {
                return bp === null || bp === void 0 ? void 0 : bp.get(verticalSpacingFor);
            }
        }
    }
    // ideally this should never get returned
    return 0;
};
